<lib-slider *ngIf="items"
            [colorScheme]="colorScheme"
            [centerElementOnClick]="true"
            [showButtons]="false">
  <lib-slider-item *ngFor="let item of items">
    <lib-picker-item
      [item]="item"
      [isSelected]="item.objectId === selectedItem?.objectId"
      [canBeDeselected]="canBeDeselected"
      [colorScheme]="colorScheme"
      (onSelect)="onItemSelected($event)"
      (onDeselect)="onItemDeselected()">
    </lib-picker-item>
  </lib-slider-item>
</lib-slider>
